export const SUCCESS = 'bets/SUCCESS';
export const FAILURE = 'bets/FAILURE';

export const success = (results) => ({
  type: SUCCESS,
  results
});
export const failure = (error) => ({
  type: FAILURE,
  error
});
